const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const fetchOwnerProfile = async () => {
  const token = localStorage.getItem('token');
  const res = await fetch(`${BASE_URL}/owner/profile/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Token ${token}` } : {})
    },
    credentials: 'include'
  });
  if (!res.ok) {
    throw new Error('Failed to fetch owner profile');
  }
  return await res.json();
};
